// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function queryMapper(routeQuery) {
  return {
          from_landmark: Js_dict.get(routeQuery, "from_landmark"),
          from_lat: Js_dict.get(routeQuery, "from_lat"),
          from_long: Js_dict.get(routeQuery, "from_long"),
          from_house: Js_dict.get(routeQuery, "from_house"),
          sender_name: Js_dict.get(routeQuery, "sender_name"),
          sender_mobile: Js_dict.get(routeQuery, "sender_mobile"),
          to_landmark: Js_dict.get(routeQuery, "to_landmark"),
          to_lat: Js_dict.get(routeQuery, "to_lat"),
          to_long: Js_dict.get(routeQuery, "to_long"),
          to_house: Js_dict.get(routeQuery, "to_house"),
          receiver_name: Js_dict.get(routeQuery, "receiver_name"),
          receiver_mobile: Js_dict.get(routeQuery, "receiver_mobile"),
          vehicle_id: Js_dict.get(routeQuery, "vehicle_id")
        };
}

function isValidParams(query_params) {
  if (Belt_Option.isSome(query_params.from_landmark) && Belt_Option.isSome(query_params.from_lat) && Belt_Option.isSome(query_params.from_long) && Belt_Option.isSome(query_params.sender_name) && Belt_Option.getWithDefault(query_params.sender_mobile, "").length === 10 && Belt_Option.isSome(query_params.to_landmark) && Belt_Option.isSome(query_params.to_lat) && Belt_Option.isSome(query_params.to_long) && Belt_Option.isSome(query_params.receiver_name) && Belt_Option.getWithDefault(query_params.receiver_mobile, "").length === 10) {
    return Belt_Option.isSome(query_params.vehicle_id);
  } else {
    return false;
  }
}

var getDefault = {
  from_landmark: undefined,
  from_lat: undefined,
  from_long: undefined,
  from_house: undefined,
  sender_name: undefined,
  sender_mobile: undefined,
  to_landmark: undefined,
  to_lat: undefined,
  to_long: undefined,
  to_house: undefined,
  receiver_name: undefined,
  receiver_mobile: undefined,
  vehicle_id: undefined
};

export {
  getDefault ,
  queryMapper ,
  isValidParams ,
}
/* No side effect */
